import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { CoachingSessionDto } from "../../../models/coach/dto/coaching-session.dto";
import { UpdateCoachingSessionCourtDto } from "../../../models/coach/dto/update-coaching-session-court.dto";
import { COACHING_SESSION_QUERY_KEY } from "./useGetCoachingSession";

export const useUpdateCoachingSessionCourt = (sessionId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationKey: ['updateCoachingSessionCourt', sessionId],
        mutationFn: (updateCoachingSessionCourtDto: UpdateCoachingSessionCourtDto) => {
            return apiClient.fetchApi<CoachingSessionDto, UpdateCoachingSessionCourtDto>({
                method: 'PUT',
                endpoint: `coachs/coaching-sessions/${sessionId}/update-court`,
                body: updateCoachingSessionCourtDto
            });
        },
        onSuccess: (updatedSession) => {
            queryClient.setQueryData<CoachingSessionDto>(COACHING_SESSION_QUERY_KEY(sessionId), updatedSession);
            queryClient.invalidateQueries({ queryKey: ['coaching-sessions'] });
            toast({
                title: translate('coaching_session.court_updated_successfully'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: translate('coaching_session.error_updating_court'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
